export const SysdigIcon = () => {
  return (
    <svg
      width="56px"
      height="56px"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 5 652 652"
    >
      <path
        d="M283.6,390.4c0.4,6.9-2.6,13.6-8,17.8c-5.8,4.1-12.8,6.1-19.9,5.7c-11.4,0.1-22.5-3.9-31.3-11l8.9-13.6
	c8,5.8,15.7,8.7,23,8.7c5.8,0,8.7-1.8,8.7-5.5v-0.3c0-2-1.5-3.7-4.5-5c-1.1-0.4-4.6-1.6-10.6-3.4c-14.5-4.3-21.8-11.6-21.8-21.9
	v-0.3c-0.2-6.6,2.7-13,7.9-17.2c5.4-4.1,12-6.3,18.8-6c9.7,0,19.2,2.9,27.2,8.5l-7.9,14.3c-7.7-4.5-14.3-6.8-19.8-6.8
	c-5.1,0-7.6,1.7-7.6,5v0.3c0,1.8,1.5,3.4,4.5,4.9c1.2,0.5,4.6,1.8,10.4,3.8c5.3,1.6,10.3,4,14.9,7.1c4.6,3.4,7.3,8.8,7.2,14.6V390.4
	z M333.9,414.4c-2.8,7.5-5.9,12.8-9.4,15.8c-4.1,3.3-9.3,4.9-14.6,4.6c-6.5,0-12.8-1.7-18.4-5l6.9-15c2.6,1.7,5.7,2.7,8.9,2.9
	c3.2,0.1,6-1.8,7.2-4.8L286,339.6h21.9l16.6,49.7l15.9-49.7H362L333.9,414.4z M420.4,390.4c0.4,6.9-2.6,13.6-8,17.8
	c-5.8,4.1-12.8,6.1-19.9,5.7c-11.4,0.1-22.5-3.9-31.3-11l8.9-13.6c8,5.8,15.7,8.7,23,8.7c5.8,0,8.7-1.8,8.7-5.5v-0.3
	c0-2-1.5-3.7-4.5-5c-1.1-0.4-4.6-1.6-10.6-3.4c-14.5-4.3-21.8-11.6-21.8-21.9v-0.3c-0.2-6.6,2.7-13,7.9-17.2c5.4-4.1,12-6.3,18.8-6
	c9.7,0,19.2,2.9,27.2,8.5l-7.9,14.3c-7.7-4.5-14.3-6.8-19.8-6.8c-5.1,0-7.6,1.7-7.6,5v0.3c0,1.8,1.5,3.4,4.5,4.9
	c1.2,0.5,4.6,1.8,10.4,3.8c5.3,1.6,10.3,4,14.9,7.1c4.6,3.4,7.3,8.8,7.2,14.6V390.4z M483.6,412.6v-6.4c-6.3,5.4-14.5,8.1-22.8,7.8
	c-8.7,0.2-17.1-3.3-23-9.7c-6.8-7.1-10.2-16.4-10.2-28.1V376c0-11.6,3.4-21,10.1-28.1c6-6.3,14.4-9.8,23.2-9.7
	c8.1-0.3,16.1,2.1,22.8,6.8v-31.9h20.7v99.5H483.6z M483.9,376c0.2-5.3-1.7-10.6-5.2-14.6c-3.1-3.6-7.7-5.7-12.5-5.6
	c-4.8-0.1-9.4,1.9-12.5,5.5c-3.6,4-5.5,9.3-5.3,14.7v0.3c-0.2,5.4,1.7,10.6,5.3,14.6c6.7,7.5,18.4,7.5,25.1,0
	c3.5-4,5.4-9.2,5.2-14.6V376z M516.8,331.6v-18.4h21.8v18.4H516.8z M517.4,412.6v-73h20.7v73H517.4z M627.4,396.1
	c0,13.5-3.4,23.4-10.2,29.6c-6.6,6-16.7,9-30.5,9c-11.2,0.1-22.3-2.5-32.3-7.6l7.1-16.9c7.5,4.3,16,6.6,24.7,6.7
	c13.9,0,20.8-5.7,20.8-17.2v-0.8c-6.8,5.3-15.2,8-23.8,7.8c-8.4,0.2-16.6-3-22.6-8.9c-6.7-6.7-10.2-15.8-9.8-25.2v-0.3
	c-0.4-9.4,3.2-18.6,9.9-25.2c6-5.9,14.1-9.1,22.5-8.9c8.4-0.2,16.6,2.2,23.6,6.8v-5.4h20.7V396.1z M606.9,372.3
	c0.1-4.6-1.8-9-5.2-12.1c-7.2-6.4-18.1-6.4-25.3,0c-3.3,3.1-5.2,7.5-5,12.1v0.3c-0.2,4.6,1.7,9.1,5,12.3c3.5,3.1,8,4.8,12.7,4.6
	c4.7,0.1,9.2-1.6,12.7-4.8c3.4-3.1,5.3-7.5,5.2-12.1V372.3z M606.9,372.3"
      />
      <path
        d="M137.4,412.3c-19.1,0.2-36.8-10.1-46-26.9c-4-7-14.5-25.6-15-26.6c-4.6-8.2,7.7-15,12.3-6.9
	c0.1,0.2,10.9,19.5,14.9,26.4c9.9,17.2,28.1,23.7,48.6,17.5c9-2.7,13,10.8,4.1,13.5C150.2,411.3,143.8,412.3,137.4,412.3
	L137.4,412.3z M137.4,412.3 M139,434.6c-26.8,0-51.9-12.5-64.5-34.4l-28.8-49.9c-2-3.4-0.8-7.7,2.6-9.6l19.6-11.3
	c3.4-2,7.7-0.8,9.6,2.5c2,3.4,0.8,7.7-2.6,9.6l-13.5,7.8l25.3,43.8c13.7,23.7,46.3,33.6,76.2,23.3c23.9-20.7,31.6-53.9,17.9-77.6
	L156.6,297c-2-3.4-0.8-7.7,2.5-9.7c3.4-2,7.7-0.8,9.6,2.6l24.2,41.9c17.3,29.9,7.8,71.3-22,96.3c-0.6,0.5-1.3,0.9-2.1,1.2
	C159.3,432.8,149.2,434.6,139,434.6L139,434.6z M139,434.6 M136.8,389.5c-11.1,0-20.5-7.4-25.3-15.7l-83.1-144
	c-4.6-8.1,7.5-15.1,12.2-7l83.1,144c2.3,3.9,8.7,10.7,16.8,8.1c8.9-2.9,13.2,10.5,4.3,13.4C142.2,389,139.6,389.5,136.8,389.5
	L136.8,389.5z M118.8,315.2c-2.5,0-4.8-1.3-6.1-3.5l-23.3-40.4c-4.6-8.1,7.5-15.1,12.2-7l19.8,34.3l12.6-7.3
	c8.1-4.6,15.1,7.5,7,12.2l-18.7,10.8C121.3,314.8,120.1,315.2,118.8,315.2L118.8,315.2z M118.8,315.2"
      />
    </svg>
  );
};
